import {Pipe, PipeTransform} from '@angular/core';
import {LabelChange} from "@app/shared/classes/label-change";
import {TitleCasePipe} from "@app/shared/pipes/title-case.pipe";

@Pipe({
  name: 'stringReplace'
})
export class StringReplacePipe implements PipeTransform {

  constructor(private titleCasePipe: TitleCasePipe) {
  }

  transform(input: string, stringChangeList: LabelChange[], titleCase?: boolean, noTitleCaseList?: string[], noTitleCasePartialList?: string[]): string {
    if (!input) {
      return '';
    } else {
      let stringPair = stringChangeList.find(stringPair => stringPair.label == input);
      let replacedString = stringPair == null ? input : stringPair.replace;
      if (titleCase) {
        return this.titleCasePipe.transform(replacedString, noTitleCaseList, noTitleCasePartialList);
      } else {
        return replacedString;
      }
    }
  }
}
